import Header from "@/components/header";
import DailyCalendar from "@/modules/schedule/dayPeriod";
import ScheduleFooter from "@/modules/schedule/footerHandler";
import ScheduleHeader from "@/modules/schedule/header";
import SchedulePageStepper from "@/modules/schedule/stepper";
import { Stack } from "@mantine/core";
import { useState } from "react";

function Schedule() {
  const [run, setRun] = useState(false);

  const handleClickStart = () => {
    setRun(true);
  };

  return (
    <Stack h="100svh">
      <Stack>
        <Header showHome showBack title="نوبت دهی" route="/dashboard" />
      </Stack>

      <Stack gap="xs">
        <SchedulePageStepper run={run} setRun={setRun} />
        <Stack px="md">
          <ScheduleHeader handleClickStart={handleClickStart} />
        </Stack>
        <DailyCalendar />
        <ScheduleFooter />
      </Stack>
    </Stack>
  );
}

export default Schedule;
